import script from "./Help.vue?vue&type=script&setup=true&lang=ts"
export * from "./Help.vue?vue&type=script&setup=true&lang=ts"

import "./Help.vue?vue&type=style&index=0&id=8604872a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8604872a"]])

export default __exports__